// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpService } from './../../../core/services/http.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../core/environment.configuration";
import * as i3 from "../../../core/services/http.service";
var GroupsService = /** @class */ (function () {
    function GroupsService(httpClient, api, httpService) {
        var _this = this;
        this.httpClient = httpClient;
        this.api = api;
        this.httpService = httpService;
        this.urls = {
            groups: function () { return _this.api + "/groups"; },
            group: function (id) { return _this.api + "/groups/" + id; },
            groupUsers: function (groupId) { return _this.api + "/groups/" + groupId + "/users"; },
            groupUser: function (groupId, userGroupId) { return _this.api + "/groups/" + groupId + "/users/" + userGroupId; }
        };
    }
    GroupsService.prototype.getList = function () {
        return this.httpClient.get(this.urls.groups()).pipe(map(function (response) { return response.groups; }));
    };
    GroupsService.prototype.get = function (id) {
        return this.httpClient.get(this.urls.group(id));
    };
    GroupsService.prototype.createGroup = function (request) {
        return this.httpClient.post(this.urls.groups(), request);
    };
    GroupsService.prototype.updateGroup = function (groupId, request) {
        return this.httpClient.put(this.urls.group(groupId), request);
    };
    GroupsService.prototype.deleteGroup = function (groupId) {
        return this.httpClient.delete(this.urls.group(groupId));
    };
    GroupsService.prototype.getUsersFromGroup = function (groupId) {
        return this.httpClient.get(this.urls.groupUsers(groupId));
    };
    GroupsService.prototype.addUserToGroup = function (groupId, request) {
        return this.httpClient.post(this.urls.groupUsers(groupId), request);
    };
    GroupsService.prototype.deleteUserFromGroup = function (groupId, userGroupId) {
        return this.httpClient.delete(this.urls.groupUser(groupId, userGroupId));
    };
    GroupsService.prototype.getGroupUsers = function (groupId) {
        return this.httpService.get(this.httpService.urls.groups.groupUsers, { urlParam: groupId });
    };
    GroupsService.ngInjectableDef = i0.defineInjectable({ factory: function GroupsService_Factory() { return new GroupsService(i0.inject(i1.HttpClient), i0.inject(i2.API_KEY), i0.inject(i3.HttpService)); }, token: GroupsService, providedIn: "root" });
    return GroupsService;
}());
export { GroupsService };



// WEBPACK FOOTER //
// ./src/app/access-management/core/services/group.service.ts.pre-build-optimizer.js